var Theme = Theme || {};

Theme.CurrentBookSearch = (function ($) {

    return {
        init: _init
    };

    function _init() {
        bindSearch();
    }

    function bindSearch() {
        $('.js-current-book-search').on('keypress', function (e) {
            if (e.key === 'Enter') {
                _executeSearch($(this));
            }
        });
        $('.js-current-book-search-submit').on('click', function () {
            _executeSearch($(this).prev('input'));
        });
    }

    function _executeSearch(inputElement) {
        var bookId = inputElement.data('book');
        var query = inputElement.val();
        var baseSearchUrl = $('.hfQuickSearchUrl').val();
        var searchUrl = '';
        if (baseSearchUrl) {
            searchUrl = baseSearchUrl.replace('{searchQuery}', query);
            searchUrl = `${searchUrl}&fl_BookID=${bookId}`;
            window.location = searchUrl;
        }
    }

})(jQuery);

// If we are in a module context, export this module
'object' === typeof module && module.exports && (module.exports = Theme.CurrentBookSearch);